const UrlBase = process.env.NODE_ENV === 'development' ?
	'http://localhost:3000' :
	'https://api.giraldoherreraabogados.co'
export { UrlBase }
